import {
  MenuDividerType,
  MenuItemGroupType,
  MenuItemType,
  SubMenuType,
} from 'antd/es/menu/interface'

export type MenuItem =
  | (MenuItemType & { 'data-cy'?: string })
  | (SubMenuType & { 'data-cy'?: string })
  | (MenuItemGroupType & { 'data-cy'?: string })
  | (MenuDividerType & { 'data-cy'?: string })

export function getMenuItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: 'group',
  disabled?: boolean
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
    disabled,
  } as MenuItem
}
